import * as React from "react";
import { User } from "../../models/User";
import * as AuthorizationStore from '../../store/Authorization';

export type AuthenticationContextType = {
    currentUser: User;
    authorizationActions: typeof AuthorizationStore.actionCreators
}

const AuthenticationContext = React.createContext<AuthenticationContextType>(undefined);

export { AuthenticationContext };

